import request from '@/utils/request'


export const articleList = (published) => {
  return request.get('/articles',{
    params: {
      status: published,// 动态传递页码
    }
  });
 
};
// 获取文章详情

export const articleDetail = (id) => {
  return request.get(`/article/${id}`);  // 通过路径传递 id
}
